<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Games from "@/services/Games";
import modalAddQuizQuestion from "@/components/modals/games/modalAddQuizQuestion.vue";

export default {
  components: {
    Layout,
    PageHeader,
    modalAddQuizQuestion
  },
  page: {
    title: "Quiz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      filterIsApprovedQuestion: false,
      filterIsRejectedQuestion: false,

      filterHasImage: false,
      filterHasNoImage: false,
      filterDifficulty: '',

      withReviews:false,
      withoutReviews:false,

      withReviewedImages:false,
      withoutReviewedImages:false,

      filterIsPending: false,
      isAuthorized: false,
      error: null,
      filterData: false,
      tableData: [],
      originalTableData: [],
      modalData:[],
      title: "Quiz",
      items: [
        {
          text: "Fanzone",
          href: "#",
        },
        {
          text: "Quiz",
          active: true,
        },
      ],
      filterInput: {
        name: '',
        gender: [],
        company_id: '',
        userStatus: [],
      },
      isBusy: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "created",
      sortDesc: true,
      fields: [
        {
          key: "team_id",
          label: "Team",
          sortable: true,
        },
        {
          key: "question",
          label: "Question",
          sortable: true,
          tdClass: "align-top quiz-question-td",
          thClass: "align-top",
        },
        {
          key: "image",
          label: "Image",
          sortable: true,
        },
        {
          key: "difficulty",
          label: "Difficulty",
          sortable: true,
        },
        {
          key: "ai_model",
          label: "AI Model",
          sortable: true,
        },
        {
          key: "is_approved",
          label: "Is Approved",
          sortable: true,
        },
        {
          key: "is_rejected",
          label: "Is Rejected",
          sortable: true,
        },
        {
          key:"review_timestamp",
          label:"Reviewed On",
          sortable: true,
        },
        {
          key: "created",
          label: "Created",
          sortable: true,
        },
        "action"
      ],
    };
  },

  computed: {
    withReviewsQuery(){
      return this.withReviews === true ? 'with_reviews=1' : '';
    },
    withoutReviewsQuery(){
      return this.withoutReviews === true ? 'with_reviews=0' : '';
    },
    withReviewedImagesQuery(){
      return this.withReviewedImages === true ? 'with_reviewed_images=1' : '';
    },
    withoutReviewedImagesQuery(){
      return this.withoutReviewedImages === true ? 'with_reviewed_images=0' : '';
    },
    withImagesQuery(){
      return this.filterHasImage === true ? 'has_image=1' : '';
    },
    withoutImagesQuery(){
      return this.filterHasNoImage === true ? 'has_image=0' : '';
    },
    withApprovedQuery(){
      return this.filterIsApprovedQuestion === true ? 'is_approved=1' : '';
    },
    withRejectedQuery(){
      return this.filterIsRejectedQuestion === true ? 'is_rejected=1' : '';
    },
    filterIsPendingQuery(){
      return this.filterIsPending === true ? 'is_pending=1' : '';
    },

    filterDifficultyQuery(){
      return this.filterDifficulty ? `difficulty=${this.filterDifficulty}` : '';
    },

    hasActiveFilters() {
      return this.filterIsApprovedQuestion ||
             this.filterIsRejectedQuestion ||
             this.filterHasImage || 
             this.filterHasNoImage ||
             this.filterDifficulty ||
             this.withReviews ||
             this.withoutReviews ||
              this.withReviewedImages ||
              this.withoutReviewedImages ||
              this.filterIsPending;
    },
    checkActiveFiltersWithReviews() {
      return this.withReviews && this.withoutReviews;
    },
    checkActiveFiltersWithImageReviews() {
      return this.withReviewedImages && this.withoutReviewedImages;
    },
    checkActiveFiltersHasImage() {
      return this.filterHasImage && this.filterHasNoImage;
    },
    
    totalQuestions() {
      return this.tableData.length;
    },

    easyQuestionsCount() {
      return this.tableData.filter(q => q.difficulty === 'easy').length;
    },

    mediumQuestionsCount() {
      return this.tableData.filter(q => q.difficulty === 'medium').length;
    },

    hardQuestionsCount() {
      return this.tableData.filter(q => q.difficulty === 'hard').length;
    },
    
  },

  methods: {
    formatDifficultyLabel(value) {
      if (!value || typeof value !== "string") return "";
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    modalAddNewPoll(){
      this.$bvModal.show('add_new_quiz_question')
    },
    // onFilter(){
    //   this.getQuizQuestion();
    // },
    async getQuizQuestion(){
      try {
        this.filterData = true;
        this.toggleBusy();
        let filters = this.getFilters();
        if (
            this.checkActiveFiltersWithReviews ||
            this.checkActiveFiltersWithImageReviews ||
            this.checkActiveFiltersHasImage
        ) {
          this.tableData = [];
          return;
        }

        const response = await Games.getQuizQuestion(filters);
        this.originalTableData =  response.data.data;
        if (
            this.checkActiveFiltersWithReviews ||
            this.checkActiveFiltersWithImageReviews ||
            this.checkActiveFiltersHasImage
        ) {
          this.tableData = [];
          return;
        }
        // // Default view: show all non-rejected items
        // this.filterIsApprovedQuestion = false;
        // this.filterIsRejectedQuestion = false;
        this.tableData = this.originalTableData;
        // this.applyFilters();
        this.totalRows = this.tableData.length
      } catch (error) {

        // this.error = error || error.response || error.response.data || error.response.data.error ? error.response.data.error : "";
        this.error = error?.response?.data?.error ?? "";
        this.tableData = [];
        this.totalRows = 0;
      } finally {
        this.toggleBusy();
      }
    },

    // applyFilters() {
    //
    //   let filteredData = [...this.originalTableData];
    //
    //   // Robust rejected handling: backend may return 1/0, '1'/'0', true/false, 'Yes'/'No', null/''
    //   const isRejected = (row) => {
    //     const v = row && row.is_rejected;
    //     return v === 1 || v === '1' || v === true || v === 'Yes';
    //   };
    //
    //   // Base: keep non-rejected unless explicitly showing rejected
    //   if (this.filterIsRejectedQuestion) {
    //     filteredData = filteredData.filter(r => isRejected(r));
    //   } else {
    //     filteredData = filteredData.filter(r => !isRejected(r));
    //   }
    //
    //   // Filter by approved questions
    //   if (this.filterIsApprovedQuestion) {
    //     filteredData = filteredData.filter(item => item.is_approved === 1);
    //   }
    //
    //   // Filter by has image
    //   if (this.filterHasImage) {
    //     filteredData = filteredData.filter(item => item.image);
    //   }
    //
    //   // Filter by difficulty
    //   if (this.filterDifficulty) {
    //     filteredData = filteredData.filter(item => item.difficulty === this.filterDifficulty);
    //   }
    //
    //   this.tableData = filteredData;
    //   this.totalRows = this.tableData.length;
    // },

    // Clear all filters
    clearFilters() {
      this.filterIsApprovedQuestion = false;
      this.filterIsRejectedQuestion = false;
      this.filterHasImage = false;
      this.filterHasNoImage = false;
      this.filterDifficulty = '';
      this.filter = null;
      this.currentPage = 1;
      this.withReviews = false;
      this.withoutReviews = false;
      this.withReviewedImages = false;
      this.withoutReviewedImages = false;
      this.filterIsPending = false;
      // this.onFilter();
      this.getQuizQuestion();
      // this.applyFilters();
    },

    getFilters(){
        const params = [];
        if(this.withReviewsQuery) params.push(this.withReviewsQuery);
        if(this.withoutReviewsQuery) params.push(this.withoutReviewsQuery);
        if(this.withReviewedImagesQuery) params.push(this.withReviewedImagesQuery);
        if(this.withoutReviewedImagesQuery) params.push(this.withoutReviewedImagesQuery);
        if(this.withImagesQuery) params.push(this.withImagesQuery);
        if(this.withoutImagesQuery) params.push(this.withoutImagesQuery);
        if(this.withApprovedQuery) params.push(`${this.withApprovedQuery}`);
        if(this.withRejectedQuery) params.push(`${this.withRejectedQuery}`);
        if(this.filterDifficultyQuery) params.push(`${this.filterDifficultyQuery}`);
        if(this.filterIsPendingQuery) params.push(`${this.filterIsPendingQuery}`);
        return params.length ? `${params.join('&')}` : '';
    },
  },
  mounted() {
    this.getQuizQuestion();
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">

        <div class="card" v-show="filterData">
          <div class="card-body">
            <div>
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                 @click="modalAddNewPoll">
                <i class="mdi mdi-plus me-2"></i>
                Create New Quiz Question
              </a>
            </div>


            <!-- Advanced Filters Section -->
            <div class="row mt-4" v-show="filterData">
              <div class="col-12">
                <div class="card border-0 shadow-sm">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <i class="mdi mdi-filter-variant text-primary me-2"></i>
                        <h6 class="mb-0 text-dark fw-semibold">Advanced Filters</h6>
                      </div>

              </div>
            </div>

                  <div class="card-body">
                    <!-- Search and Pagination Row -->
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <div class="d-flex align-items-center">
                          <label class="form-label fw-medium me-3 mb-0">Show:</label>
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                            class="me-3"
                            style="width: auto;"
                          ></b-form-select>
                          <span class="text-muted">entries per page</span>
                        </div>
                      </div>
                      
                      <div class="col-md-6">
                        <div class="d-flex align-items-center justify-content-end">
                          <label class="form-label fw-medium me-2 mb-0">Search:</label>
                          <div class="position-relative" style="width: 250px;">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              placeholder="Search questions..."
                              class="form-control"
                            ></b-form-input>
                            <i class="mdi mdi-magnify position-absolute top-50 end-0 translate-middle-y me-2 text-muted"></i>
                          </div>
                        </div>
                </div>
              </div>

                    <!-- Filter Controls Row -->
                    <div class="row g-3">
                      <!-- Status Filters -->
                      <div class="col-md-3">
                        <div class="border rounded p-3 h-100">
                          <h6 class="text-dark fw-semibold mb-3">
                            <i class="mdi mdi-check-circle-outline text-success me-1"></i>
                           Question Status
                          </h6>
                          <div class="d-flex flex-column gap-2">
                            <div class="form-check form-switch">
                              <input 
                                v-model="filterIsApprovedQuestion" 
                           type="checkbox"
                           class="form-check-input"
                           id="filterIsApprovedQuestion"
                    />
                              <label class="form-check-label fw-medium" for="filterIsApprovedQuestion">
                                <span class="badge bg-success-subtle text-success me-2">✓</span>
                                Approved Only
                              </label>
                  </div>
                            <div class="form-check form-switch">
                              <input 
                                v-model="filterIsRejectedQuestion" 
                                type="checkbox"
                                class="form-check-input"
                                id="filterIsRejectedQuestion"
                              />
                              <label class="form-check-label fw-medium" for="filterIsRejectedQuestion">
                                <span class="badge bg-danger-subtle text-danger me-2">✗</span>
                                Show Rejected
                              </label>
              </div>
                            <div class="form-check form-switch">
                              <input
                                v-model="filterIsPending"
                                type="checkbox"
                                class="form-check-input"
                                id="filterIsPending"
                              />
                              <label class="form-check-label fw-medium" for="filterIsPending">
                                <span class="badge bg-success-subtle text-success me-2">✓</span>
                                Show Pending
                              </label>
                            </div>
                            <div class="form-check form-switch">
                              <input 
                                v-model="filterHasImage" 
                                type="checkbox"
                                class="form-check-input"
                                id="filterHasImage"
                              />
                              <label class="form-check-label fw-medium" for="filterHasImage">
                                <span class="badge bg-info-subtle text-info me-2">🖼</span>
                                With Images
                              </label>
                            </div>
                            <div class="form-check form-switch">
                              <input
                                  v-model="filterHasNoImage"
                                  type="checkbox"
                                  class="form-check-input"
                                  id="filterHasNoImage"
                              />
                              <label class="form-check-label fw-medium" for="filterHasNoImage">
                                <span class="badge bg-danger-subtle text-danger me-2">🖼</span>
                                Without Images
                  </label>
                </div>
              </div>
                        </div>
                      </div>

                      <!--Reviews Status-->
                      <div class="col-md-3">
                        <div class="border rounded p-3 h-100">
                          <h6 class="text-dark fw-semibold mb-3">
                            <i class="mdi mdi-check-circle-outline text-success me-1"></i>
                            Review Status
                          </h6>
                          <div class="form-check form-switch">
                            <input
                                v-model="withReviews"
                                type="checkbox"
                                class="form-check-input"
                                id="filterWithReviews"
                            />
                            <label class="form-check-label fw-medium" for="filterWithReviews">
                              <span  class="badge bg-success-subtle text-success me-2">✓</span>
                              With Reviews
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input
                                v-model="withoutReviews"
                                type="checkbox"
                                class="form-check-input"
                                id="filterWithoutReviews"
                            />
                            <label class="form-check-label fw-medium" for="filterWithoutReviews">
                              <span  class="badge bg-danger-subtle text-danger me-2">✗</span>
                              Without Reviews
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input
                                v-model="withReviewedImages"
                                type="checkbox"
                                class="form-check-input"
                                id="filterWithReviewedImages"
                            />
                            <label class="form-check-label fw-medium" for="filterWithReviewedImages">
                              <span class="badge bg-info-subtle text-info me-2" >🖼</span>
                              With Reviewed Images
                            </label>
                          </div>
                          <div class="form-check form-switch">
                            <input
                                v-model="withoutReviewedImages"
                                type="checkbox"
                                class="form-check-input"
                                id="filterWithoutReviewedImages"
                            />
                            <label class="form-check-label fw-medium" for="filterWithoutReviewedImages">
                              <span class="badge bg-danger-subtle text-danger me-2">🖼</span>
                              Without Reviewed Images
                            </label>
                          </div>
                        </div>

                      </div>

                      <!-- Difficulty Filter -->
                      <div class="col-md-3">
                        <div class="border rounded p-3 h-100">
                          <h6 class="text-dark fw-semibold mb-3">
                            <i class="mdi mdi-speedometer text-warning me-1"></i>
                            Difficulty Level
                          </h6>
                          <select 
                            v-model="filterDifficulty" 
                            class="form-select"
                          >
                            <option value="">All Difficulties</option>
                            <option value="easy">Easy Questions</option>
                            <option value="medium">Medium Questions</option>
                            <option value="hard">Hard Questions</option>
                          </select>
                          <div class="mt-2">
                            <small class="text-muted">
                              <i class="mdi mdi-information-outline me-1"></i>
                              Filter questions by complexity level
                            </small>
                          </div>
                          <router-link
                            to="/monitor/quiz/bulk-approval"
                            class="btn btn-primary btn-sm w-100 mt-3"
                          >
                            <i class="mdi mdi-checkbox-multiple-marked-outline me-1"></i>
                            Bulk approve (3+ reviews)
                          </router-link>
                          <small class="text-muted d-block mt-1 text-center">
                            Open queue for questions with enough reviewer reviews
                          </small>
                        </div>
                      </div>

                      <!-- Statistics Card -->
                      <div class="col-md-3">
                        <div class="border rounded p-3 h-100">
<!--                          <h6 class="text-dark fw-semibold mb-3">-->
<!--                            <i class="mdi mdi-chart-bar text-primary me-1"></i>-->
<!--                            Statistics-->
<!--                          </h6>-->
                          <div class="d-flex flex-column gap-3">
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="fw-medium">
                                <i class="mdi mdi-clipboard-list-outline text-primary me-2"></i>
                                Total Questions
                              </span>
                              <span class="badge bg-primary fs-6">{{ totalQuestions }}</span>
                            </div>
                            <hr class="my-0" />
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="text-muted">
                                <i class="mdi mdi-circle text-success me-2"></i>
                                Easy
                              </span>
                              <span class="badge bg-success-subtle text-success">{{ easyQuestionsCount }}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="text-muted">
                                <i class="mdi mdi-circle text-warning me-2"></i>
                                Medium
                              </span>
                              <span class="badge bg-warning-subtle text-warning">{{ mediumQuestionsCount }}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="text-muted">
                                <i class="mdi mdi-circle text-danger me-2"></i>
                                Hard
                              </span>
                              <span class="badge bg-danger-subtle text-danger">{{ hardQuestionsCount }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div :class="hasActiveFilters ? 'justify-content-between' : 'justify-content-end'" class="d-flex  align-items-center mt-2">
                      <!-- Active Filters Summary -->
                      <div v-if="hasActiveFilters" class="mt-2">
                        <div class="d-flex align-items-center flex-wrap gap-2">
                          <span class="text-muted fw-medium">Active filters:</span>
                          <span v-if="filterIsApprovedQuestion" class="badge bg-success">
                          <i class="mdi mdi-check me-1"></i>Approved
                        </span>
                          <span v-if="filterIsRejectedQuestion" class="badge bg-danger">
                          <i class="mdi mdi-close me-1"></i>Rejected
                        </span>
                          <span v-if="filterHasImage" class="badge bg-info">
                          <i class="mdi mdi-image me-1"></i>With Images
                        </span>
                          <span v-if="filterHasNoImage" class="badge bg-secondary">
                          <i class="mdi mdi-image-off me-1"></i>Without Images
                        </span>
                          <span v-if="filterDifficulty" class="badge bg-warning">
                          <i class="mdi mdi-speedometer me-1"></i>{{ formatDifficultyLabel(filterDifficulty) }}
                        </span>
                          <span v-if="this.withReviews" class="badge bg-success">
                          <i class="mdi mdi-check me-1"></i>With Reviews
                        </span>
                          <span v-if="this.withoutReviews"  class="badge bg-danger">
                          <i class="mdi mdi-close me-1"></i>Without Reviews
                        </span>

                          <span v-if="this.withReviewedImages" class="badge bg-success">
                          <i class="mdi mdi-image me-1"></i>With Reviewed Images
                        </span>
                          <span v-if="this.withoutReviewedImages"  class="badge bg-danger">
                          <i class="mdi mdi-image me-1"></i>Without Reviewed Images
                        </span>
                          <span v-if="this.filterIsPending"  class="badge bg-danger">
                          <i class="mdi mdi-check me-1"></i>Pending
                        </span>
                        </div>

                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <button
                            class="btn btn-success btn-sm"
                            @click="getQuizQuestion"
                        >
                          <i class="mdi mdi-filter me-1"></i>
                          Search
                        </button>
                        <button
                            class="btn btn-outline-danger btn-sm"
                            @click="clearFilters"
                        >
                          <i class="mdi mdi-filter-remove me-1"></i>
                          Clear All
                        </button>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- Table -->
            <div class="table-responsive mb-0" v-show="filterData">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No Data Found"
              >

<!--                <template v-slot:cell(active_from)="data">-->
<!--                                <span-->
<!--                                    style="font-size:14px;"-->
<!--                                    class="badge"-->
<!--                                    :class="{-->
<!--                                    'bg-danger': data.item.status === 'past' || data.item.status === 'incomplete',-->
<!--                                    'bg-success': data.item.status === 'active' || data.item.status === 'future',-->
<!--                                  }"-->
<!--                                >{{data.item.active_from}}</span>-->
<!--                </template>-->
<!--                <template v-slot:cell(active_to)="data">-->
<!--                                <span-->
<!--                                    style="font-size:14px;"-->
<!--                                    class="badge"-->
<!--                                    :class="{-->
<!--                                    'bg-danger': data.item.status === 'past' || data.item.status === 'incomplete',-->
<!--                                    'bg-success': data.item.status === 'active' || data.item.status === 'future',-->
<!--                                  }"-->
<!--                                >{{data.item.active_to}}</span>-->
<!--                </template>-->
                <template v-slot:cell(question)="data">
                  <div class="quiz-table-question-preview">
                    {{ data.item.question }}
                  </div>
                </template>
                <template v-slot:cell(is_approved)="data">
                  {{ data.item.is_approved === 1 ? 'Yes' : 'No' }}
                </template>
                <template v-slot:cell(is_rejected)="data">
                  {{ data.item.is_rejected === 1 ? 'Yes' : 'No' }}
                </template>


                <template v-slot:cell(image)="data">
                  {{ data.item.image ? 'Yes' : 'No' }}
                </template>
                <template v-slot:cell(review_timestamp)="data">
                    {{ data.item.review_timestamp ? data.item.review_timestamp : 'N/A' }}
                </template>

<!--                <template  v-slot:cell(statistics)="data">-->
<!--                  <span>{{data.item.statistics.total_votes}}</span>-->

<!--                </template>-->

                <template v-slot:cell(action)="data">
                  <a
                    :href="`/games/quiz/question/${data.item.id}`"
                    class="quiz-view-question-link d-inline-flex align-items-center gap-1 text-decoration-none"
                    title="View Question"
                  >
                    <i class="uil uil-eye font-size-18" style="color: #5b73e8;"></i>
                  </a>
                </template>


                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row" v-show="filterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalAddQuizQuestion @onRefresh="getQuizQuestion"></modalAddQuizQuestion>
  </Layout>
</template>

<style scoped>
/* Filter Card Styling */
.card {
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

/* Status Filter Cards */
.border {
  border-color: #e9ecef !important;
  transition: all 0.2s ease;
}

/* .border:hover {
  border-color: #5b73e8 !important;
  box-shadow: 0 2px 8px rgba(91, 115, 232, 0.1);
} */

/* Badge Styling */
.badge {
  font-size: 0.75rem;
  font-weight: 500;
}

.bg-success-subtle {
  background-color: rgba(40, 167, 69, 0.1) !important;
  color: #28a745 !important;
}

.bg-danger-subtle {
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #dc3545 !important;
}

.bg-info-subtle {
  background-color: rgba(13, 202, 240, 0.1) !important;
  color: #0dcaf0 !important;
}

.bg-warning-subtle {
  background-color: rgba(255, 193, 7, 0.1) !important;
  color: #ffc107 !important;
}

/* Form Switch Styling */
.form-check-input:checked {
  background-color: #5b73e8;
  border-color: #5b73e8;
}

.form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
}

/* Search Input Styling */
.form-control:focus {
  border-color: #5b73e8;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
}

/* Button Styling */
.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  transform: translateY(-1px);
}

/* Active Filter Badges */
.badge.bg-success {
  background-color: #28a745 !important;
}

.badge.bg-danger {
  background-color: #dc3545 !important;
}

.badge.bg-info {
  background-color: #0dcaf0 !important;
}

.badge.bg-warning {
  background-color: #ffc107 !important;
  color: #000 !important;
}

.badge.bg-primary {
  background-color: #5b73e8 !important;
}

/* Icon Styling */
.mdi {
  font-size: 1.1em;
}

/* Header Styling */
.card-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .d-flex.flex-column.gap-2 {
    gap: 0.5rem !important;
  }
  
  .position-relative {
    width: 100% !important;
  }
}

/* Animation for filter changes */
.badge {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Custom scrollbar for select dropdowns */
.form-select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
}

/* Enhanced focus states */
.form-check-input:focus,
.form-select:focus,
.form-control:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.25);
  border-color: #5b73e8;
}

/* Subtle hover effects */
.form-check-label:hover {
  color: #5b73e8;
  cursor: pointer;
}

/* Loading state styling */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Question column: wrap long text across multiple lines */
::v-deep td.quiz-question-td {
  max-width: 28rem;
  min-width: 14rem;
  vertical-align: top;
}

.quiz-table-question-preview {
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.45;
}

.quiz-view-question-link {
  color: #5b73e8;
}

.quiz-view-question-link:hover {
  color: #4458b8;
  text-decoration: underline !important;
}
</style>
